/**
 * Created by tomers on 3/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/agentStateAnchor.tmpl");
    var Button = require("ui/button/Button");
    var positionsUtility = require("personalization-utils/positionsUtility");

    var AgentStateAnchorView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AgentStateAnchorView = Marionette.ItemView.extend({
            template: template,
            withUIComponents: true,
            className: "agent-state-anchor-view anchor hide",
            ui: {
                subTitle: ".sub-title span",
                awayReasonsContainer: ".away-reasons-container",
                awayReasons: ".away-reasons span",
                editButtonDefaultState: ".edit-button-default-state",
                editButtonAwayReasons: ".edit-button-away-reasons",
                stateIcon: ".current-state-icon-img",
                stateText: ".current-state-icon-text"
            },
            uiComponents: {
                editButtonDefaultState: {
                    type: Button,
                    options: {
                        el: "view.ui.editButtonDefaultState",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonDefaultStateClick"
                    }
                },
                editButtonAwayReasons: {
                    type: Button,
                    options: {
                        el: "view.ui.editButtonAwayReasons",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonAwayReasonsClick"
                    }
                }
            },
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            updateDefaultLoginStatusAfterFetch: function(currentDefaultAgentState) {
                this._updateDefaultLoginStatusAfterFetch(currentDefaultAgentState);
            },
            updateAgentReasonsAfterFetch: function(isEnabled, agentReasonsCollection) {
                this._updateAgentReasonsAfterFetch(isEnabled, agentReasonsCollection);
            },

            _initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.featureId = options.featureId;
            },

            _onRender: function () {
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.RIGHT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
            },

            _updateDefaultLoginStatusAfterFetch: function(currentDefaultAgentState){
                this.currentDefaultAgentState = currentDefaultAgentState;
                var iconClass = this.currentDefaultAgentState.get("iconClass") ? this.currentDefaultAgentState.get("iconClass").replace(".", "") : "";
                var iconTitle = this.currentDefaultAgentState.get("availabilityTitle");
                this.ui.stateIcon.addClass(iconClass);
                this.ui.stateText.text(iconTitle);
                this._showView();
            },

            _updateAgentReasonsAfterFetch: function(isEnabled, agentReasonsCollection) {
                this.isAgentReasonsEnabled = isEnabled;
                this.agentReasonsCollection = agentReasonsCollection;
                if (this.isAgentReasonsEnabled) {
                    this.ui.awayReasonsContainer.removeClass("hide");

                    var agentReasonsArr = [];
                    this.agentReasonsCollection.each(function(agentReasonModel) {
                        agentReasonsArr.push(agentReasonModel.getText());
                    });

                    var agentReasonsText = LE.translator.translate("LEPersonalization.webAgent.agentState.anchor.currentAwayReasons.noReasons.text");
                    if (agentReasonsArr.length > 0) {
                        agentReasonsText = agentReasonsArr.join(", ");
                    }

                    this.ui.awayReasons.text(agentReasonsText);
                }

                this._showView();
            },

            _showView: function() {
                if (!_.isUndefined(this.currentDefaultAgentState) && (!this.isAgentReasonsEnabled || !_.isUndefined(this.agentReasonsCollection))) {
                    var subTitleKey = (this.isAgentReasonsEnabled) ? "LEPersonalization.webAgent.agentState.anchor.description.withAgentReasons.text" : "LEPersonalization.webAgent.agentState.anchor.description.withoutAgentReasons.text";
                    this.ui.subTitle.text(LE.translator.translate(subTitleKey));

                    this.$el.removeClass("hide");
                }
            },


            _onEditButtonDefaultStateClick: function () {
                this.trigger("navigateToDefaultAgentStateEdit");
            },

            _onEditButtonAwayReasonsClick: function() {
                this.trigger("navigateToMultipleAgentStateEdit");
            }
        });
    });

    return AgentStateAnchorView;

});
